import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';
import {
  BaseDialog,
  ItemWrapper,
  LabelButton,
} from '../../../styles/common/Dialog';

export const Dialog = styled(BaseDialog)`
  background-color: ${ColorSF2.skyBlue};
`;
export const MessageWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`;
export const ButtonWrapper = styled(ItemWrapper)`
  background-color: ${ColorSF2.skyBlue};
  margin-top: 10px;
  margin-bottom: 20px;
  justify-content: space-evenly;
`;
export const ImportButton = styled(LabelButton)`
  background: ${ColorSF2.white} 0% 0% no-repeat padding-box;
  font-weight: normal;
`;
